import React from "react";
import { Rocket } from "lucide-react";
import { Link } from "react-router-dom";
import useReveal from "../hooks/useReveal";

export default function GrowCTA({ content = {} }) {
  const { ref, cls } = useReveal();
  return (
    <section className="bg-white py-28">
      <div ref={ref} className={`max-w-[820px] mx-auto px-6 text-center ${cls}`}>
        <div className="w-20 h-20 rounded-2xl bg-[#eefafa] flex items-center justify-center mx-auto mb-8">
          <Rocket size={38} className="text-[#2ec9c9]" />
        </div>
        <h2 className="gp-heading text-[2.6rem] sm:text-[3.2rem]">{content.grow_title || "Grow faster with GiftVouchers.app"}</h2>
        <p className="text-[#5a6b80] text-[1.2rem] mt-5">{content.grow_subtitle || "Free setup. No minimum term. Just results."}</p>
        <Link to="/signup" className="gp-btn-teal inline-block rounded-full px-10 py-4 text-[1.05rem] font-medium mt-9">
          Get started
        </Link>
      </div>
    </section>
  );
}
